export const getBearerToken = (token?: string) => {
  if (!token) {
    return token;
  }

  return `Bearer ${token}`;
};
